module.exports = __webpack_public_path__ + "static/media/office_4.be06093b.jpg";